export default __webpack_public_path__ + "static/media/partner-ammacus.9047d93d.png";